import { STORAGE } from "./constants";

function applyThemeColor(theme: string): void {
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute(
    "content",
    theme === "dark" ? "#111512" : "#eef0ed",
  );
}

export function initTheme(): void {
  const saved = localStorage.getItem(STORAGE.theme);
  const theme = saved === "dark" || saved === "light"
    ? saved
    : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  document.documentElement.dataset.theme = theme;
  applyThemeColor(theme);
}

export function toggleTheme(): void {
  const next = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
  document.documentElement.dataset.theme = next;
  localStorage.setItem(STORAGE.theme, next);
  applyThemeColor(next);
}
